import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.div `
  display: flex;
  align-items: center;
  margin-left: auto;
  transform: translateX(14px);

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
const Button = styled.button `
  display: inline-flex;
  background: none;
  border: 0;
  color: currentColor;
  height: 48px;
  padding: 0;
  place-content: center;
  place-items: center;
  width: 48px;

  svg {
    display: block;
    height: 20px;
    width: 20px;
  }

  &:focus {
    outline: auto;
  }
`;
const MobileHeaderStyles = {
    Button,
    Container,
};
export default MobileHeaderStyles;
